import { render, staticRenderFns } from "./VErrors.vue?vue&type=template&id=c44e38a8&"
import script from "./VErrors.vue?vue&type=script&lang=js&"
export * from "./VErrors.vue?vue&type=script&lang=js&"
import style0 from "./VErrors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports